import api from 'services/api'
import {
  Pagination,
  PatchRangeBody,
  PostRangeBody,
  RangeReviewBody,
  RangeVersion,
  TeamRange,
  TrackingData
} from './interfaces'

export const getTeamRangesData = async (office: string) => {
  const response = await api.get<TeamRange[]>(
    `backoffice/v2/politica_alcadas/listar_alcadas`,
    {
      params: { escritorio: office }
    }
  )
  return response.data
}

export const getRangeVersion = async (office: string) => {
  const response = await api.get<RangeVersion>(
    `backoffice/v2/politica_alcadas/obter_ultima_revisao_alcada`,
    {
      params: { escritorio: office }
    }
  )
  return response.data
}

export const postRangeUpdate = async (payload: PostRangeBody) => {
  const response = await api.post(
    `backoffice/v2/politica_alcadas/revisao_alcada`,
    payload
  )
  return response.data
}

export const patchRangeUpdate = async (payload: PatchRangeBody) => {
  const response = await api.patch(
    `backoffice/v2/politica_alcadas/revisao_alcada`,
    payload
  )
  return response.data
}

export const sendRangeUpdate = async (version: number) => {
  const response = await api.post(`backoffice/v2/politica_alcadas/solicita_analise`, {
    codigoVersao: version
  })
  return response.data
}

export const setRangeVisualization = async (version: number) => {
  const response = await api.post(`backoffice/v2/politica_alcadas/visualizar_revisao `, {
    CodigoVersao: version
  })
  return response.data
}

export const postRangeReview = async (payload: RangeReviewBody) => {
  const response = await api.post(
    `backoffice/v2/politica_alcadas/realizar_analise`,
    payload
  )
  return response.data
}

export const getTrackingData = async (pagination: Pagination) => {
  const response = await api.get<TrackingData[]>(
    `backoffice/v2/politica_alcadas/listar_historico`,
    {
      params: pagination
    }
  )
  return response.data
}
